import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-customercare',
  templateUrl: './customercare.component.html',
  styleUrls: ['./customercare.component.scss'],
})
export class CustomercareComponent {

  loader: boolean = false;

  constructor( public auth: AuthService,public router: Router) { }

  faq(){
    if(!this.auth.loged()){
      this.router.navigate(['/faq']);  
    }else{
      this.router.navigate(['/faq1']);  
    }
  }

  policy(){
    if(!this.auth.loged()){
      this.router.navigate(['/policy']);  
    }else{
      this.router.navigate(['/policy1']);  
    }
  }

}
